var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamsterAngry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_77968)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_152_77968)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.2 308.4C74 308.1 62.8 310.8 63.3 313.5C62.4 321.7 100.9 320.1 108.4 319.8C112.3 319.6 122.8 317.5 124.8 313.8C126.6 310.6 121.3 308.2 117.4 308.4H117.2Z",
    fill: "#8699A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M238.6 307.8C195.4 307.5 166.6 310.2 167.2 312.9C166.3 321.1 222.4 319.5 229.8 319.2C233.7 319 244.2 316.9 246.2 313.2C248 310 242.7 307.6 238.8 307.8H238.6Z",
    fill: "#8699A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.901 41.6004C233.501 45.8004 248.901 53.3004 253.301 63.0004C267.301 94.5004 240.001 109.7 241.001 114C252.701 165.3 275.501 256.5 239.201 307.1C232.701 316.2 225.301 310.9 227.301 306.7C225.501 316.7 216.601 313.8 214.801 311.3C212.501 308 212.701 317.7 205.701 309.5C185.701 286.1 198.101 282.1 189.501 280.8C159.801 276.4 132.201 279.3 132.001 283.2C131.501 295.4 114.501 307.5 109.501 311.1C100.201 317.9 98.7006 307.5 100.401 304.1C103.001 320 84.0006 314.8 89.0006 302.3C90.8006 318.6 82.3006 311.6 78.0006 307.5C56.8006 287.3 57.2006 205.4 85.0006 114C87.6006 105.4 61.9006 95.2004 75.9006 60.4004C80.7006 48.4004 89.2006 42.6004 98.0006 33.8004C132.401 -0.599604 161.101 2.1004 165.601 2.6004C173.801 3.6004 214.301 8.4004 228.001 40.4004C229.401 43.6004 228.601 36.9004 228.801 41.0004L229.901 41.6004Z",
    fill: "url(#paint0_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5002 285.201C83.8002 281.601 110.1 288.801 126.7 292.301C126.3 301.201 104.6 315.701 102.8 309.301C95.9002 315.401 96.1002 314.001 90.1002 309.501C78.8002 319.101 70.3002 295.601 68.2002 285.101H69.5002V285.201Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4 295.3C225.4 286.9 241.3 287.5 248.7 288.5C244.8 286.9 249 294.8 248.7 295.2C243.6 303.1 238 312.5 228.1 312.4C229 312 227.2 309.7 227 309.5C223.6 314 221.7 311.8 218.2 314C216.9 312.7 214.8 311.4 214.1 309.7C206.2 313.3 201.3 306.4 201.6 301.8L198.4 295.3Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.6 11.4004C107.1 31.9004 76.5998 55.8004 86.9998 82.9004C94.9998 103.7 101.6 99.3004 93.7998 126.8C76.2998 189.1 57.9998 294 100.6 313.2C44.6998 328.1 67.9998 181.5 72.2998 157C74.4998 144.8 90.1998 115.4 84.9998 109.2C59.9998 79.6004 77.1998 51.4004 96.1998 37.8004C109.1 28.7004 114.1 14.0004 125.7 10.4004L126.6 11.4004Z",
    fill: "#BC5A28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4 116C236.8 102 263.8 101.1 257 72.1001C254 59.4001 238.8 47.8001 227.8 39.2001C227.6 39.2001 227.4 39.2001 227.2 39.2001C226.1 39.4001 222.1 32.8001 220.9 32.5001C220.1 32.3001 212.6 27.0001 216.1 31.2001C224.3 40.9001 239.9 55.5001 243.4 60.4001C262.4 87.2001 232.9 107.8 236.2 122.8C248.8 180.6 260.6 280 228.1 307.6C248.6 315.4 256.1 255.5 257.1 240.2C259.5 204 252.6 149.7 241.4 116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7 66.5997C172.8 24.4997 148.7 46.6997 145.5 64.5997C144.5 70.4997 105.5 42.7997 89.3003 58.8997C64.2003 83.8997 116 107.4 121.3 127.7C129.4 159.2 79.9003 184.4 94.5003 242.2C105.4 285.3 205.8 282.1 224.1 257.4C269.9 195.6 202.1 163.6 210.9 127.2C215.3 109 255.2 84.0997 245.2 66.6997C232.9 45.4997 200.4 66.0997 196.9 63.8997L194.7 66.5997Z",
    fill: "url(#paint1_radial_152_77968)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.301 286.801C130.001 282.301 148.101 279.601 166.401 279.801C180.501 280.001 195.501 282.101 207.901 289.101C209.001 289.701 211.501 288.201 210.101 287.401C197.901 280.601 183.801 278.401 170.001 277.801C150.401 277.001 130.701 280.001 111.801 284.801C110.001 285.101 110.501 287.201 112.301 286.801Z",
    fill: "#88391E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.9 39.2999C243 49.5999 259.8 68.0999 255.3 88.7999C253.9 95.0999 249.9 100.2 245.7 104.8C243.7 106.9 239.8 110.1 240.5 113.4C243.8 128.6 247.9 143.5 250.5 158.9C252.8 172.7 254.5 186.7 255.4 200.6C256.9 223.4 256.6 246.6 252.7 269.2C250.8 280.4 247.9 292 242.2 302.1C240.3 305.5 237.8 308.9 234.5 311C233.2 311.8 231.9 312.2 230.4 312.2C225.3 312.3 228.7 307.7 229.9 305.1C229 305.2 228 305.4 227.1 305.5C225.6 308.8 223.4 315.7 218.2 312.2C215.2 310.2 215.4 304.2 215.3 301.2C214.4 301.5 213.4 301.7 212.5 302C212.8 304.5 213 307 212.8 309.5C212.6 312.1 211.8 311.5 210 310.2C205.7 306.9 202.1 302 199.2 297.5C196.2 293 194.5 288.2 193.5 283C192.6 278.5 187.4 279.4 183.6 278.8C175.1 277.6 166.4 277.7 157.8 277.5C149.8 277.3 141.2 278.1 133.5 280.5C130.3 281.5 130.7 282.6 129.9 285.4C128.4 291.1 124.7 296.1 120.8 300.4C116.9 304.6 112.3 307.9 107.5 310.9C104.4 312.8 102.9 312.6 101.7 309.2C101 307.4 101.1 305.4 101.8 303.6C100.9 303.8 99.8999 304 98.9999 304.2C99.5999 308.2 98.5999 315.4 92.7999 312.2C88.9999 310.1 88.4999 305.4 89.3999 301.6C88.4999 301.8 87.4999 302 86.5999 302.2C87.3999 306.1 89.4999 311.5 82.5999 310.7C80.6999 310.5 78.9999 309 77.6999 307.7C73.7999 303.6 71.6999 297.6 70.0999 292.2C64.2999 273.6 63.4999 253.3 63.6999 234C63.9999 206.1 68.0999 178.3 74.9999 151.3C76.7999 144.2 78.8999 137.2 81.0999 130.3C82.1999 126.8 83.4999 123.2 84.6999 119.7C85.4999 117.5 87.3999 114.4 87.3999 112.1C87.3999 109.4 83.2999 106.2 81.6999 104.3C70.7999 91.2999 71.3999 75.3999 77.5999 60.1999C79.8999 54.4999 82.8999 49.2999 87.2999 44.8999C90.4999 41.6999 94.5999 39.4999 97.8999 36.3999C102 32.5999 105.4 28.0999 109.4 24.1999C114 19.8999 119.1 16.1999 124.5 12.9999C158.9 -7.40009 206.2 3.99991 226.2 38.9999C226.7 39.7999 229.4 38.7999 229 38.1999C210.5 5.79991 169.3 -6.00009 134.8 6.89991C125 10.5999 116 16.3999 108.2 23.3999C104.1 26.9999 100.5 31.0999 96.8999 35.1999C93.6999 38.7999 89.2999 41.0999 85.6999 44.3999C72.3999 56.7999 65.5999 80.6999 73.7999 97.4999C75.9999 102 79.2999 105.7 82.5999 109.5C83.3999 110.5 84.4999 111.5 84.6999 112.8C84.9999 114.7 82.6999 118.5 81.9999 120.3C80.4999 124.4 79.0999 128.5 77.7999 132.6C68.9999 159.8 63.7999 188.2 61.6999 216.7C60.1999 238.1 60.3999 260 64.3999 281.1C66.1999 290.5 68.8999 306.2 78.3999 311.4C81.0999 312.9 84.7999 312.3 87.4999 311.2C92.1999 309.4 90.2999 305.4 89.4999 301.6C89.2999 300.8 86.7999 301.5 86.6999 302.2C85.3999 307.8 87.7999 314.3 94.2999 314.6C100.7 314.9 102.7 309 101.9 303.6C101.8 302.8 99.2999 303.6 99.0999 304.2C97.2999 309.1 100.1 315.8 105.9 313.5C114.3 310.2 122.5 302.4 127.8 295.3C130.4 291.7 132.7 287.3 133.4 282.8C133.7 280.6 139 280.5 140.9 280.2C147.4 279.1 153.9 278.9 160.4 279.1C165.5 279.2 170.7 279.2 175.8 279.6C177.9 279.8 179.9 280 182 280.3C184.2 280.6 188.1 280.5 189.9 281.6C190.8 282.2 190.9 284.3 191.1 285.2C191.7 288.1 192.6 290.8 193.8 293.5C195.6 297.4 198.2 300.9 200.8 304.2C203.3 307.3 206.6 312 210.7 313.1C217.2 314.8 215.8 304.6 215.5 301.4C215.4 300.7 212.6 301.3 212.7 302.2C212.9 307.2 213.2 314.9 219.9 314.4C226.3 313.9 227.9 310.5 230.2 305.3C230.5 304.6 227.8 305 227.4 305.7C226.7 307.1 222.8 312.2 226 313.1C227.8 313.6 229.6 313.8 231.4 313.5C235 313 238.1 310.8 240.6 308.2C249.5 299 252.7 284.2 255.1 272.1C259.3 251 259.8 229.2 258.9 207.7C257.7 178.8 253 150.1 246 122C245.1 118.5 242.2 113.5 244.1 110C245.1 108 247 106.4 248.5 104.8C252.9 99.9999 256.7 94.8999 258.3 88.3999C263.5 67.6999 245.7 48.3999 229.8 38.2999C228.8 37.7999 226.4 38.9999 226.9 39.2999Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.3 68.7004C172.1 54.3004 158.5 18.1004 133.8 20.7004C110.9 23.1004 102.7 63.1004 126.7 69.7004C135.5 72.1004 143.5 71.8004 149.4 69.2004L149.3 68.7004Z",
    fill: "#E99800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.301 20.0006C173.101 18.3006 162.701 57.0006 180.001 67.0006C200.701 79.0006 221.401 62.3006 214.001 39.2006C211.301 30.6006 205.501 20.6006 195.201 21.4006V20.0006H195.301Z",
    fill: "#E99800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.501 115.3C150.201 114.7 151.6 124.2 167.4 123.1C174.5 122.6 177.9 116.1 164.7 115.5L164.501 115.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 65.0004C217.6 58.1004 220.6 60.0004 221.4 70.2004C218.5 67.3004 216 65.6004 210 64.2004V65.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8 33.7992C242.3 33.8992 239 17.6992 236.7 9.39921C235 3.09921 224.3 -0.900785 218.3 1.69921C211.7 4.59921 202.2 8.09921 205.5 18.1992C205.6 18.4992 222.8 33.7992 222.8 33.7992Z",
    fill: "#D0732E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.7 26.6992C212.3 20.4992 225.4 5.69922 229.4 5.69922C230.8 5.69922 234.2 8.19922 236.3 15.5992C239.5 26.7992 230.9 34.0992 220.6 30.8992L218.7 26.6992Z",
    fill: "#F6B4BA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 31.8998C226.1 32.7998 233.4 32.5998 237 26.6998C240 21.8998 238.5 15.0998 236.5 10.2998C235 6.69978 232.7 3.29978 228.5 4.99978C220.5 8.29978 213.8 18.4998 216.5 27.0998C216.8 28.1998 219.6 27.3998 219.3 26.2998C216.9 18.6998 221.9 11.5998 227.9 7.29978C231.3 4.79978 232.9 9.29978 234.1 12.1998C235.6 15.8998 236.2 19.9998 235.4 23.8998C234 30.5998 227.3 31.1998 221.7 30.2998C220.7 30.0998 218.4 31.5998 220 31.8998Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.3 34.5997C228.7 34.4997 235.7 33.0997 238.7 26.6997C241.4 20.8997 240.2 10.2997 236.3 5.29968C227.2 -6.40032 205.6 2.79968 202.6 15.3997C202.4 16.0997 205.2 15.6997 205.4 14.8997C208.2 2.79968 227.4 -4.80032 234.5 7.79968C236.7 11.5997 237 16.3997 236.9 20.6997C236.8 29.3997 232.1 33.0997 223.5 33.2997C222.7 33.3997 220.4 34.5997 222.3 34.5997Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M222.9 10.5999C227.1 13.2999 232.4 21.4999 229.6 26.7999C228.6 28.6999 226.6 31.6999 224.1 31.9999C220.7 32.4999 220.7 29.9999 218.9 27.0999C212.2 23.9999 222.6 9.09991 222.1 10.5999H222.9Z",
    fill: "#E50048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M203.9 15.1995C205.9 9.49949 212.4 3.99949 217.3 8.59949C221.5 12.3995 217.7 22.5995 217.9 28.6995C213.2 23.9995 208.4 18.0995 202.9 14.1995L203.9 15.1995Z",
    fill: "#A5221D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4 3.19924C217.8 4.49924 220.5 5.09924 222.1 6.89924C225 4.19924 229.2 4.09924 232.5 5.69924C229.4 1.19924 222.9 0.899244 217.5 2.09924L216.4 3.19924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 8.3993C234.2 11.4993 233.3 22.7993 230.7 29.2993C239 24.6993 235.6 3.1993 228.4 8.3993H227.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.201 34.9003C82.2005 35.0003 85.7005 17.5003 88.2005 8.50033C90.1005 1.70033 101.601 -2.59967 108.101 0.200332C115.201 3.30033 125.501 7.10033 122.001 18.1003C121.901 18.3003 103.201 34.9003 103.201 34.9003Z",
    fill: "#D0732E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7 27.0998C114.6 20.3998 100.5 4.2998 96.1004 4.2998C94.6004 4.2998 90.9004 6.9998 88.6004 15.0998C85.2004 27.1998 94.4004 35.0998 105.6 31.6998L107.7 27.0998Z",
    fill: "#F6B4BA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.501 30.9997C99.6007 31.8997 92.9007 31.5997 90.1007 25.4997C88.2007 21.3997 89.1007 16.2997 90.4007 12.0997C91.0007 10.2997 91.8007 8.59969 92.8007 6.89969C94.1007 4.89969 94.5007 4.49969 96.5007 5.59969C103.801 9.69969 109.701 18.7997 107.101 27.1997C106.801 28.2997 109.601 27.8997 109.901 26.8997C112.801 17.4997 105.601 7.59969 97.4007 3.49969C93.2007 1.49969 90.3007 5.99969 88.8007 9.19969C86.4007 14.2997 85.2007 20.7997 87.3007 26.1997C90.1007 33.3997 98.8007 33.5997 105.201 32.6997C106.601 32.4997 107.401 30.6997 105.501 30.9997Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.7 34.3001C96.6004 34.2001 90.2004 32.3001 88.3004 24.7001C86.9004 19.0001 87.8004 11.6001 90.4004 6.30014C93.9004 -0.799858 102.1 -0.799858 108.8 1.30014C115.5 3.40014 120.6 8.20014 122.2 15.1001C122.4 16.0001 125.2 15.3001 125 14.3001C122 1.10014 100.1 -8.29986 89.9004 3.20014C84.9004 8.90014 84.5004 17.1001 85.2004 24.3001C86.1004 33.4001 94.7004 35.7001 102.5 35.9001C103.6 35.8001 105.6 34.3001 103.7 34.3001Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.1 9.70033C98.6003 12.6003 92.8003 21.4003 95.9003 27.2003C97.0003 29.3003 99.2003 32.5003 101.8 32.9003C105.5 33.5003 105.5 30.8003 107.4 27.6003C114.7 24.2003 103.4 8.10033 103.9 9.70033H103.1Z",
    fill: "#E50048"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.601 14.6999C121.501 8.49991 114.401 2.59991 109.101 7.49991C104.601 11.6999 108.701 22.6999 108.501 29.2999C113.601 24.1999 118.701 17.7999 124.801 13.5999L123.601 14.6999Z",
    fill: "#A5221D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1 1.70006C108.6 3.10006 105.6 3.80006 103.9 5.70006C100.8 2.80006 96.2002 2.70006 92.7002 4.40006C96.0002 -0.39994 103.1 -0.69994 108.9 0.60006L110.1 1.70006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3001 5.10059C85.4001 10.4006 86.8001 32.2006 102 31.5006C90.2001 28.8006 87.4001 10.2006 99.2001 9.50059C98.6001 6.30059 96.8001 6.50059 94.2001 5.60059L95.3001 5.10059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.7 287.5C210.1 298.3 215.1 304.3 219.9 313.3C203.4 314.7 194.2 292.9 190.9 280.8C196.9 282.3 201.6 287.3 207.8 288.5L210.7 287.5Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.7 285.6C113.5 292.8 111.2 305.4 106.4 312.2C119.4 308.9 130.2 293.9 131.1 281.3C125 281.6 119.7 284.2 113.6 285.1V285.6H113.7Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 136.7C145.801 136.8 118.601 150.6 110.301 176.5C102.701 200.5 119.301 228.3 139.801 235C168.201 244.3 238.801 228.7 223.301 178.9C216.301 156.2 191.9 134.8 169.9 136.9L168.101 136.7Z",
    fill: "url(#paint2_radial_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2002 298.2C75.8002 303.4 83.0002 314.3 86.3002 305.1C80.9002 305.5 74.6002 301.9 75.6002 296.2L75.2002 298.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8003 304.6C92.1003 307.8 92.4003 310 96.2003 310.9C95.5003 308.9 94.5003 305.7 93.3003 303.2L92.8003 304.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 304.6C103.7 305.9 103.3 307 103.6 308.4C109 310.1 114.7 305.5 116.1 300.3C112.5 303.7 107.4 307.3 102.5 304.6H104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5 300.7C206.5 302.5 210.4 304.4 211 307.5C208 307.4 205.7 304.7 204.2 302.4L205.5 300.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2 303.3C216.6 308 223.3 315.8 223.4 308.3C220.2 309.4 218.2 306.1 217.2 303.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8 178.9C249.6 184.1 254.9 188.3 253.6 178.7C253.6 182.8 249.5 182.9 247.4 179.9L246.8 178.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.101 174.3C258.401 177.3 259.701 184.2 262.901 179.6C260.201 178.2 258.801 175.3 258.101 172.7V174.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7005 125.4C39.7005 156.3 32.2005 176.4 31.7005 184.2C31.3005 190.1 34.5005 192.9 40.4005 197.4C50.6005 205.1 56.9005 199.3 61.1005 194.1C66.3005 187.5 82.3005 171.1 84.7005 167.5C97.4005 148.5 99.0005 95.7002 78.7005 123.3L76.7005 125.4Z",
    fill: "url(#paint3_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4005 152.5C57.9005 164.4 76.3005 199.1 49.4005 200.5C20.5005 202 38.8005 168.1 45.4005 157.1C46.5005 155.3 48.0005 156.2 49.0005 154.4L51.4005 152.5Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3007 129.7C71.8007 131.4 62.3007 142.1 49.8007 155.5C45.3007 160.3 29.0007 177.8 33.4007 186.6C39.5007 166.3 75.2007 149.6 78.8007 130.4L78.3007 129.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8002 114.4C67.9002 130.9 50.0002 149.5 36.0002 170.4C33.3002 174.4 28.2002 181 29.1002 186.3C30.5002 194.2 37.7002 193.8 39.8002 186.8C40.1002 185.9 37.4002 186.8 37.1002 187.1C33.5002 190.6 32.5002 196.5 37.7002 199.2C41.0002 200.9 44.5002 198.5 45.7002 195.4C46.0002 194.7 43.2002 195.2 42.9002 195.8C38.6002 204.3 51.7002 200.9 55.6002 199.1C60.5002 196.9 64.6002 192.7 68.4002 188.9C73.5002 183.8 78.1002 178.2 82.5002 172.5C83.2002 171.7 80.4002 172 79.9002 172.6C74.5002 179.5 68.9002 186.2 62.5002 192.2C59.5002 195 56.0002 198 51.9002 199.3C48.0002 200.5 43.0002 200.6 45.6002 195.4C44.7002 195.5 43.7002 195.7 42.8002 195.8C41.3002 199.8 38.3002 197.1 37.2002 194.9C35.8002 191.9 37.6002 189 39.7002 187C38.8002 187.1 37.9002 187.2 37.0002 187.3C36.6002 188.6 35.8002 191.8 33.9002 189.9C32.8002 188.7 32.1002 186.8 31.8002 185.2C31.5002 183.4 32.5002 181.3 33.2002 179.7C36.0002 173.1 40.6002 167.2 44.9002 161.5C57.8002 144.4 72.9002 128.8 89.0002 114.7C90.2002 113.6 87.4002 113.9 86.8002 114.4Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3998 189.8C43.5998 191.9 41.8998 196.3 41.7998 199.7C41.7998 200.3 44.5998 199.9 44.5998 198.9C44.5998 196.1 46.1998 191.7 48.4998 190C49.7998 189.1 46.9998 189.4 46.3998 189.8Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9 183.601C37.8 185.601 34.6 189.601 34 194.101C34 194.501 36.7 194.201 36.8 193.301C37.3 189.501 40 185.701 43.5 184.001C45.2 183.201 42.6 183.201 41.9 183.601Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.8005 191C48.2005 194.9 45.5005 197.1 51.3005 197.9C47.8005 195 49.7005 193.3 48.7005 189.9L47.8005 191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3007 186.3C37.6007 188.1 35.8007 190.8 38.9007 195.3C39.5007 192.2 41.2007 190.3 42.0007 187.6L42.3007 186.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.5 124.199C282.5 158.299 288.3 178.999 288.1 186.799C287.9 192.799 284.6 195.199 278.3 199.099C267.5 205.899 261.6 199.499 258 193.999C253.4 186.899 239.7 168.699 236.9 165.399C222.5 147.899 229.1 92.6994 246.8 121.899L248.5 124.199Z",
    fill: "url(#paint4_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.6 155C265 166.3 242.3 197.8 268.9 201.6C297.6 205.7 282.4 170.3 276.8 158.7C275.9 156.8 274.9 159.3 274 157.4L272.6 155Z",
    fill: "#F2908F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.499 128.399C252.799 130.699 261.299 142.199 272.499 156.699C276.499 161.899 294.499 183.699 286.199 189.999C281.899 169.299 247.799 148.399 245.899 128.999L246.499 128.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237 113C251.1 127.7 263.9 143.8 275.1 160.9C279.2 167.3 283.2 173.9 286.1 180.9C286.9 182.9 287.7 185.1 287.8 187.2C287.9 188.3 287.4 189.3 286.9 190.3C285.1 194.2 283.1 191.6 282.5 188.7C281.6 189 280.7 189.4 279.8 189.7C281.4 191.6 282.4 193.4 282.1 196C281.6 199.9 277.1 200.8 275.9 196.7C275 197 274 197.2 273.1 197.5C275.1 202.4 270 200.8 267.1 199.7C263.4 198.3 260.3 195.2 257.6 192.4C251.2 185.8 246.1 178 241.1 170.3C240.4 169.2 237.7 170.3 238.5 171.6C245.1 181.8 252.7 194.7 263.6 200.8C268 203.3 279.3 205.4 275.9 196.8C275.4 195.5 272.7 196.2 273.1 197.6C275.8 207.4 290.4 197.8 282.4 188.6C281.7 187.7 279.4 188.3 279.7 189.6C281.4 197.9 288 195.5 290.4 189C292.1 184.3 287.6 177.3 285.6 173.3C274 150.8 257 130.1 239.6 111.9C238.7 110.8 236 112 237 113Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.5 191.699C272.7 193.699 274 198.099 273.8 200.999C273.7 202.299 276.6 201.699 276.6 200.699C276.8 197.399 275.6 192.799 273.1 190.499C272.3 189.799 269.6 190.899 270.5 191.699Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276 186.099C279.5 188.199 281.9 192.299 282.1 196.299C282.1 197.199 285 196.599 284.9 195.499C284.7 191.099 281.9 186.899 278.2 184.699C277.4 184.299 274.8 185.399 276 186.099Z",
    fill: "#A82E25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.3 192.2C270.5 196 273.1 198.5 267.2 198.7C270.9 196.2 269.2 194.2 270.5 191L271.3 192.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3 188C281.8 190.2 283.4 193.1 279.9 197.2C279.6 194.1 278 192 277.5 189.3L277.3 188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M239.3 172C238.3 188.9 248.2 200.7 256.9 215.3C256.8 197.2 254.5 181.1 239.3 170V172Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.3004 215.501C67.1004 209.801 95.9004 172.001 79.4004 173.801C59.5004 176.001 65.0004 203.401 61.4004 214.201L63.3004 215.501Z",
    fill: "#AA3306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3 41.9002C106.5 73.6002 160 85.1002 159.4 48.8002C159.2 38.2002 139.5 21.0002 124.3 41.4002L123.3 41.9002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.999 41.1998C171.899 50.0998 172.699 56.4998 177.299 64.8998C180.399 68.8998 182.199 67.2998 187.599 69.0998C195.299 71.6998 202.099 67.8998 205.299 64.3998C215.799 36.8998 185.999 17.5998 175.499 39.1998L173.999 41.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.1 69.2C137.9 72.3 125.4 67.8 121.5 56.5C118.8 48.8 121.3 39.8 128 35.1C137.6 28.3 150.6 33.1 155.5 42.9C159.1 50 159.5 61.5 152.4 66.7C151.2 67.6 154 67.3 154.6 66.9C163.3 60.5 161.8 46.9 156.4 38.9C150.1 29.6 136.9 29.2 127.6 33.9C118.6 38.3 115.8 49 118.9 58C123.1 70.3 138.1 73.3 149.3 70.2C151 69.7 150.7 68.7 149.1 69.2Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.2 65.6001C193.9 70.4001 182.1 72.3001 176.7 61.4001C173.3 54.6001 174.1 45.8001 177.3 39.2001C182.7 28.3001 196.5 30.7001 202.8 39.5001C208.4 47.3001 209 60.8001 200.9 67.2001C199.7 68.1001 202.6 67.8001 203.1 67.4001C212.8 59.8001 211.1 44.2001 203.3 35.9001C196.1 28.2001 182.1 28.7001 175.9 37.3001C170.5 44.8001 170.1 56.6001 175.1 64.4001C181.8 74.8001 195.8 70.7001 204.8 66.1001C206.5 65.2001 203.9 65.2001 203.2 65.6001Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.9 38.7002C124.6 39.3002 118.1 60.5002 135.3 67.0002C144.6 70.5002 150.7 58.9002 150.4 52.2002C150 43.5002 141.1 37.0002 136.4 40.0002L136.9 38.7002Z",
    fill: "#A94116"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.5 40.6998C169.6 52.4998 182.4 71.6998 194 65.3998C210.6 56.2998 194.3 29.6998 181.4 41.9998L181.5 40.6998Z",
    fill: "#A94116"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.1 43.7002C129.9 44.4002 124.7 60.2002 137.4 64.6002C144.3 67.0002 149.1 58.3002 148.9 53.3002C148.7 46.9002 142.3 42.3002 138.7 44.6002L139.1 43.7002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.4 42.0996C179.2 42.7996 174 58.5996 186.7 62.9996C193.6 65.3996 198.4 56.6996 198.2 51.6996C198 45.2996 191.6 40.6996 188 42.9996L188.4 42.0996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.2 40.4997C125.1 42.2997 124.2 52.6997 132 53.2997C136.2 53.6997 137.7 47.6997 137 44.6997C136.1 40.7997 131.8 39.0997 130.1 40.9997L130.2 40.4997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3 44.0994C181.1 41.2994 174.2 54.6994 183.2 56.0994C186.5 56.5994 188.8 56.3994 189.1 53.3994C189.4 49.4994 186.8 44.3994 185.1 44.4994L185.3 44.0994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6 55.7002C142.1 55.8002 140.7 60.1002 144.3 61.4002C146.2 62.1002 147.5 59.8002 147.4 58.4002C147.3 56.6002 145.5 55.4002 144.5 56.0002L144.6 55.7002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 56.5996C192.7 56.7996 191.5 59.9996 194.3 60.7996C195.8 61.1996 196.9 59.4996 196.9 58.4996C196.9 57.1996 195.5 56.2996 194.7 56.7996L194.8 56.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.7 52.3001C185.6 48.3001 194.6 44.6001 203.4 40.5001C206 39.3001 203.7 36.9001 201.5 37.9001C192.7 42.0001 183.6 45.7001 174.8 49.7001C172.1 50.8001 174.4 53.3001 176.7 52.3001Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.999 39.5999C124.299 39.5999 126.199 40.4999 127.499 40.8999C130.899 41.9999 134.299 43.1999 137.699 44.4999C144.399 46.8999 151.099 49.2999 157.599 52.0999C158.499 52.4999 161.099 51.1999 159.799 50.5999C153.099 47.6999 146.199 45.2999 139.399 42.7999C135.999 41.5999 132.599 40.3999 129.199 39.1999C127.699 38.6999 125.699 37.6999 124.099 37.7999C122.899 37.7999 121.099 39.5999 122.999 39.5999Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.8 50.0997C174.3 31.2997 192.2 26.1997 203.1 39.1997C198 41.1997 178.8 49.1997 173.9 50.8997L173.8 50.0997Z",
    fill: "url(#paint5_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1 37.5997C130.9 39.5997 151.5 47.4997 158.1 49.5997C157.4 43.5997 154.1 36.8997 145.1 33.1997C139.4 30.8997 129.3 32.4997 125 37.5997H125.1Z",
    fill: "url(#paint6_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6 34.7998C141.8 35.3998 138.8 39.5998 141.6 40.8998C150.7 44.9998 147.2 34.3998 143.9 35.0998L144.6 34.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 35.5C184.1 37.1 183.1 43.6 189.4 41.7C194.5 40.2 188.2 34.4 185.8 34.8L185 35.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.099 21.1997C144.099 23.4997 149.099 29.7997 155.799 32.5997C156.999 33.0997 159.099 31.3997 157.399 30.6997C150.699 27.8997 145.699 21.5997 138.699 19.2997C137.499 18.8997 135.399 20.6997 137.099 21.1997Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.3 33.0002C180.6 29.5002 186.7 25.5002 193.1 22.0002C193.3 21.9002 193.9 21.4002 193.5 21.1002C192.5 20.4002 190.4 20.9002 189.4 21.2002C187.8 21.7002 188.1 23.1002 189.8 22.5002C189.9 22.5002 191.3 22.4002 190.9 22.1002C191 21.8002 191.2 21.5002 191.3 21.2002C184.9 24.7002 178.9 28.7002 172.5 32.2002C170.9 33.1002 173.4 33.5002 174.3 33.0002Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.2 31.6001C175 27.4001 187.3 18.9001 192.4 19.2001C192.8 21.9001 176.4 29.4001 173.9 31.4001L173.2 31.6001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9 30.6998C154 26.2998 144.6 17.9998 139.3 18.1998C141.9 23.2998 153.6 26.9998 156.9 31.1998V30.6998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.3 51.5002C174.8 55.1002 188.5 48.7002 191 47.6002C195.9 45.4002 201.2 44.5002 206 43.0002C206.9 36.9002 191.8 44.9002 189.1 46.0002C184.1 48.0002 178.1 49.6002 173.6 52.0002L173.3 51.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.4 39.5C119 41.9 126.5 43.7 128.2 44.2C131.6 45.2 134.7 46.7 138 47.9C142.1 49.4 146.5 50.1 150.5 51.9C152.9 52.9 155.4 55.1 157.8 55.6C162.4 52.2 147.9 49 144.2 47.2C138.9 44.6 133.5 42.4 127.9 40.6C126.5 40 124.9 39.6 123.4 39.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.7 144.4C160.9 142.9 164.1 141.2 167.6 140.6C171.5 140 174.8 142.9 177.4 145.3C178.1 145.9 180.7 144.9 180 144.2C176.8 141.3 173.6 139 169.2 139C164.8 139 160.4 141.5 156.5 143.3C154.8 144.2 156.5 144.9 157.7 144.4Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.4 111.1C132.4 104.3 150.9 85.0996 167.8 85.0996C175.3 85.0996 201.9 99.0996 202.2 113C201.2 122 197.7 128.9 189.2 133.8C183.7 136.9 178.8 128.9 165.2 130.2C157.9 130.9 149.9 134 146.4 134.7C143.2 135.3 133.3 125.1 131.1 111.3L131.4 111.1Z",
    fill: "#671500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.2 121.999C164.3 117.699 158.6 117.799 156.1 122.299C154.3 125.399 154.4 130.599 158.9 130.899C159.6 130.999 161 129.899 159.7 129.799C156.7 129.599 156.8 125.899 157.4 123.799C157.8 122.599 158.5 121.399 159.4 120.499C161.4 118.699 164.3 121.099 165.4 122.799C165.7 123.399 167.6 122.699 167.2 121.999Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2 124.1C168.8 123 169.9 121 171.5 121.5C172.4 121.8 173.1 122.6 173.7 123.4C174.9 125 175.7 127.4 175.4 129.5C175.3 130.3 177.3 129.9 177.4 129.2C177.8 126.3 176.4 122.6 173.9 121C170.8 119 167.9 121.5 166.3 124.1C165.9 124.9 167.9 124.7 168.2 124.1Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.499 130.999C155.899 127.699 154.199 124.299 158.899 120.499C161.599 118.299 165.399 119.399 166.699 123.499C170.199 117.999 177.699 121.999 176.099 129.599C170.699 129.399 165.399 129.199 158.599 131.099L158.499 130.999Z",
    fill: "#D93442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7 91.1994C158.2 93.8994 159.2 97.8994 160.8 101.599C164.8 102.299 171.8 103.799 173.5 101.699C174.6 100.399 175.8 91.7994 178.8 87.6994C173.6 84.7994 170.8 86.5994 167.7 83.8994C163.9 85.8994 157.8 88.0994 156.6 87.8994L157.7 91.1994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.7 91.4996C150.9 97.4996 152.3 109.4 173.1 102.5C163 103.7 159.3 105.8 156.2 88.5996L150.7 91.4996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.7 89.2003C155.7 91.2003 156.3 93.6003 157 95.8003C157.5 97.5003 157.7 100.5 158.8 102C161.6 105.5 169.8 103.6 173.3 103C173.8 102.9 174.7 102.7 174.9 102.1C176.5 97.6003 177.3 92.9003 179.5 88.7003C179.8 88.1003 177.1 88.3003 176.7 89.1003C174.5 93.3003 173.7 98.1003 172.1 102.5C172.6 102.2 173.2 101.9 173.7 101.6C171.1 102 162.1 104.2 161.2 100C160.3 96.2003 159.3 91.9003 157.5 88.4003C157.1 87.6003 154.4 88.6003 154.7 89.2003Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.7 102.399C169.3 98.5995 168.4 94.6995 168.5 90.8995C168.5 90.3995 165.7 90.7995 165.7 91.6995C165.6 95.3995 166.5 99.1995 165.9 102.899C165.8 103.599 168.6 103.099 168.7 102.399Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.2 149.4C168.6 149.1 161.3 151.8 155.6 148.2C159.1 143.9 174.3 142.7 178.7 147.4L175.2 149.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.999 134.4C141.599 130.3 134.999 125.3 132.899 117.7C131.299 112.2 134.099 106.7 137.599 102.6C141.499 97.9003 146.999 94.5003 152.299 91.7003C154.799 90.4003 157.399 89.3003 159.999 88.3003C161.699 87.6003 165.999 85.5003 167.899 86.0003C177.899 88.6003 187.899 94.7003 194.899 102.2C198.499 106 201.099 110.8 200.899 116.2C200.599 124.4 192.499 130.1 186.199 133.8C184.599 134.8 186.099 136.2 187.399 135.4C199.199 128.4 208.899 117.2 199.799 103.9C195.999 98.3003 190.099 94.1003 184.299 90.7003C179.799 88.0003 173.799 84.5003 168.399 83.9003C166.099 83.6003 162.899 85.2003 160.799 85.9003C157.699 86.9003 154.799 88.2003 151.799 89.7003C145.599 92.7003 139.699 96.7003 134.999 101.9C131.099 106.3 128.799 111.8 129.699 117.7C130.999 126 139.199 132 145.699 136.1C146.899 136.6 149.399 135.2 147.999 134.4Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.999 84.7999C169.299 81.4999 169.299 78.2999 169.499 74.9999C169.599 73.6999 166.699 74.1999 166.699 75.2999C166.499 78.5999 166.499 81.7999 166.199 85.0999C165.999 86.3999 168.899 85.9999 168.999 84.7999Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.6 135.7C161 131.1 173 130.4 185.5 135.2C186.7 135.7 188.8 133.9 187.1 133.3C173.6 128.2 160.7 129.1 147.3 134.1C145.5 134.7 147.1 136.2 148.6 135.7Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.799 62.2996C187.399 59.3996 198.499 57.9996 208.899 54.2996C211.699 53.2996 209.099 52.1996 207.299 52.8996C197.399 56.4996 186.499 57.6996 176.299 60.4996C173.799 61.1996 174.199 62.9996 176.799 62.2996Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.5 58.4998C145.3 57.2998 133.2 55.1998 121.1 52.9998C119.8 52.7998 118.2 54.5998 120.1 54.8998C132.2 57.1998 144.3 59.1998 156.5 60.3998C157.8 60.5998 159.4 58.6998 157.5 58.4998Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.8 61.5994C179.4 71.1994 197.6 71.7994 203.2 64.6994C205.3 62.0994 206.7 57.6994 206.9 54.3994C201.6 55.6994 196.5 57.6994 191.1 58.5994C188.3 59.0994 178.8 61.1994 176.5 62.2994L176.8 61.5994Z",
    fill: "url(#paint7_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 55.4C122.9 65 135.9 72.5 147.4 69.1C152.2 67.7 155.6 64.7 157 60C150.9 59.8 145.2 58.3 139.2 57.9C133.7 57.5 127.9 56.4 122.5 55.5C121.8 55.4 120.9 55.2 120.2 55L121.1 55.4Z",
    fill: "url(#paint8_linear_152_77968)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M175.4 60.0994C181.4 59.3994 203.4 51.3994 207.7 51.3994C209.1 55.2994 184.9 59.2994 179.5 60.5994C178.1 60.8994 176.8 61.1994 175.5 61.3994C174.6 60.8994 175.5 61.1994 175.5 61.0994V60.0994H175.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.3 53.4998C115.4 49.0998 146.1 56.5998 153.2 56.6998C154.9 56.6998 158 57.1998 158.2 58.9998C152.9 59.3998 121.9 54.3998 119.7 53.7998L119.3 53.4998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.3 70.2001C159.6 73.6001 164.7 74.4001 167.2 76.8001C167.9 77.5001 169.3 77.0001 169.8 76.3001C171.7 73.8001 175.4 72.6001 177.9 70.7001C179.4 69.5001 177.1 68.9001 176.1 69.6001C173.2 71.8001 169.4 73.1001 167.1 76.0001C168 75.8001 168.9 75.7001 169.7 75.5001C167.5 73.3001 162.2 72.2001 161 69.3001C160.7 68.3001 157.9 69.2001 158.3 70.2001Z",
    fill: "#9E3022"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M159.5 70.1001C160.8 73.1001 169.2 78.9001 176.6 70.8001C180.5 66.4001 161.2 62.0001 159.3 70.1001H159.5Z",
    fill: "#E50048"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_77968",
    x1: 344.251,
    y1: 135.821,
    x2: -135.186,
    y2: 204.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_152_77968",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.743 77.8719) scale(241.483 241.483)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0924728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3111,
    stopColor: "#F8EFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5651,
    stopColor: "#F1E0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#EDD7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#ECD4B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_152_77968",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.744 142.797) scale(143.849 143.849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0924728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3111,
    stopColor: "#F8EFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5651,
    stopColor: "#F1E0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#EDD7BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#ECD4B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_77968",
    x1: 39.2573,
    y1: 151.282,
    x2: 88.4838,
    y2: 163.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_77968",
    x1: 215.999,
    y1: 123.708,
    x2: 307.967,
    y2: 209.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_77968",
    x1: 215.751,
    y1: 11.9109,
    x2: 123.663,
    y2: 108.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_77968",
    x1: 192.752,
    y1: -10.0436,
    x2: 100.661,
    y2: 86.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_77968",
    x1: 227.895,
    y1: 23.5002,
    x2: 135.804,
    y2: 119.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_77968",
    x1: 198.672,
    y1: -4.3952,
    x2: 106.58,
    y2: 92.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00995922,
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    stopColor: "#FDC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "#F7A800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#F08200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#EF7800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9516,
    stopColor: "#EE7402"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_77968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_152_77968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261.8,
    height: 322.1,
    fill: "white",
    transform: "translate(29 -2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamsterAngry);
export default __webpack_public_path__ + "static/media/hamster_angry.2cd953708a7117fad60226c3efaef5b0.svg";
export { ForwardRef as ReactComponent };